module.exports = __webpack_public_path__ + "_app/img/hotels.dca60331.svg";